import clsx from 'clsx';
import { SkeletonSurface } from './skeletonPrimitives';

/** Flexible block for payer / one-off layouts — same premium sheen as route skeletons. */
export function SkeletonBlock({
  className,
  rounded = 'rounded-[16px]',
}: {
  className?: string;
  /** Override radius e.g. `rounded-full` for avatars */
  rounded?: string;
}) {
  return <SkeletonSurface className={clsx(rounded, className)} />;
}
